import { useTenant } from '@alison/whitelabel/react';
import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode, SyntheticEvent } from 'react';

// The guidebook is a self-contained export with its own tokens; map them onto the
// tenant stylesheet's --wl-* vars so a white-labelled tenant sees its own brand.
const TENANT_TOKEN_BRIDGE = `:root {
  --font-sans: var(--wl-font-sans);
  --primary-main: var(--wl-primary);
  --primary-hover: var(--wl-primary-dark);
  --primary-bg: var(--wl-primary-bg);
  --secondary-main: var(--wl-secondary);
  --secondary-dark: var(--wl-secondary-dark);
  --info-main: var(--wl-info);
  --text-primary: var(--wl-text);
  --text-secondary: var(--wl-text-secondary);
  --bg-page: var(--wl-bg-page);
  --bg-muted: var(--wl-bg-muted);
  --border-default: var(--wl-border);
  --border-card: var(--wl-border);
  --border-strong: var(--wl-border-strong);
  --gradient-primary: var(--wl-gradient-primary);
}`;

function GuidebookPage(): ReactNode {
  const tenant = useTenant();

  const applyTenantStyles = (event: SyntheticEvent<HTMLIFrameElement>) => {
    const doc = event.currentTarget.contentDocument;
    if (!tenant.stylesheet || !doc) return;
    const link = doc.createElement('link');
    link.rel = 'stylesheet';
    link.href = tenant.stylesheet;
    const bridge = doc.createElement('style');
    bridge.textContent = TENANT_TOKEN_BRIDGE;
    // Bridge only once the --wl-* vars exist, else every mapped token is invalid meanwhile.
    link.onload = () => doc.head.append(bridge);
    doc.head.append(link);
  };

  return (
    <iframe
      src="/guidebook.html"
      title="Guidebook"
      onLoad={applyTenantStyles}
      style={{ display: 'block', width: '100vw', height: '100vh', border: 0 }}
    />
  );
}

export const Route = createFileRoute('/guidebook/')({
  component: GuidebookPage,
});
